var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loyalty-cta" }, [
    _c("p", [_vm._v(_vm._s(_vm.preamble))]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "button button--secondary",
        on: {
          click: function ($event) {
            return _vm.signInToLoyalty()
          },
        },
      },
      [_vm._v(_vm._s(_vm.text))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }